export default __webpack_public_path__ + "static/media/easy_tuna_salad.1a6c7578.jpg";